import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'whatsapp',
  templateUrl: 'whatsapp.html',
})

export class WhatsappPage {

  data: any = [];

  constructor(public navParams: NavParams) {

  }

  ionViewDidLoad() {
    this.data = this.navParams.get('data');
    console.log(this.data);
  }

  send(element) {
    let baseUrl = "https://wa.me/<%tel%>?text=<%msg%>";
    let phone = element.phone.replaceAll('+', '').replaceAll(' ', '');
    let text = encodeURIComponent(element.text)
    let link = baseUrl.replace('<%tel%>', phone).replace('<%msg%>',text);
    console.log(link);
    window.open(link);
  }

}


// WEBPACK FOOTER //
// ./src/pages/whatsapp/whatsapp.ts